import { Container, Row, Col, Card } from "react-bootstrap";
import {
  FiCpu,
  FiGlobe,
  FiLayers,
  FiSmartphone,
  FiTrendingUp,
  FiZap,
} from "react-icons/fi";

const solutions = [
  {
    title: "I need more customers",
    text: "We design growth-focused websites, landing pages, and lead funnels that turn attention into real conversations.",
    icon: <FiTrendingUp />,
  },
  {
    title: "I need to automate my business",
    text: "We build workflows and AI-powered automations that reduce manual tasks and improve consistency.",
    icon: <FiCpu />,
  },
  {
    title: "I need a mobile app",
    text: "We create customer-facing and internal apps that make services easier to access and use.",
    icon: <FiSmartphone />,
  },
  {
    title: "I need a dashboard",
    text: "We create operations dashboards that make your numbers, inventory, clients, and reports visible in one place.",
    icon: <FiLayers />,
  },
  {
    title: "I need AI",
    text: "We help you adopt AI tools that support sales, support, reporting, and smarter internal operations.",
    icon: <FiZap />,
  },
  {
    title: "I need a modern online presence",
    text: "We create polished digital experiences that reflect your business quality and build trust instantly.",
    icon: <FiGlobe />,
  },
];

function Solutions() {
  return (
    <div className="page-hero">
      <Container>
        <div className="text-center mb-4">
          <h1 className="hero-title">
            Solutions organized around your business needs
          </h1>
          <p className="section-lead mx-auto mt-3">
            Instead of leading with technology, we begin with the outcome you
            want and shape the right solution around it.
          </p>
        </div>
        <Row className="g-4 mt-2">
          {solutions.map((solution) => (
            <Col md={6} lg={4} key={solution.title}>
              <Card className="service-card h-100">
                <div className="service-icon">{solution.icon}</div>
                <h5 className="fw-bold">{solution.title}</h5>
                <p className="text-muted mb-0">{solution.text}</p>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}

export default Solutions;
